<template>
  <div class="rounded-lg border border-ink-100 bg-ink-50/40 px-2.5 py-2 text-center">
    <div class="text-2xs font-medium text-ink-500 uppercase tracking-wider">{{ label }}</div>
    <div class="font-mono text-sm font-semibold mt-0.5" :class="toneClass">{{ value }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: String, required: true },
  tone:  { type: String, default: 'neutral' }, // accent | warn | danger | neutral
});

const toneClass = computed(() => ({
  accent:  'text-accent-700',
  warn:    'text-warn-700',
  danger:  'text-danger-600',
  neutral: 'text-ink-800',
}[props.tone] || 'text-ink-800'));
</script>
